export default __webpack_public_path__ + "static/media/Avatar-22-noback.58e49fd7.png";